import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { HelpApiService } from '../help-api.service';
import { IHelp } from '../../../models/help.interface';
import { ListHelpQuery, GetHelpByIdQuery } from '../../../graphql/queries/help.query';
import { cloneDeep } from 'lodash';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
  })
export class HelpGqlService implements HelpApiService {
    private currentHelpTopic: BehaviorSubject<string>;

    constructor(
        private apollo: Apollo,private sanitizer: DomSanitizer
      ) {
        this.currentHelpTopic = new BehaviorSubject<string>(localStorage.getItem('helpTopic'));
      }

    public get currentHelpTopicValue(): string {
        return this.currentHelpTopic.value;
      }
    
    public setCurrentHelpTopicValue(topic: string) {
      if (topic && topic.length > 0) {
        localStorage.setItem('helpTopic', topic);
        this.currentHelpTopic.next(topic);
      }
    }

    public getList(): Observable<IHelp[]> {
          //console.log(`HelpGql.getList()`);
          return this.apollo
        .query({
          query: ListHelpQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => 
          { 
            const returnHelps =cloneDeep( result.data['helpTexts'] as IHelp[]);
            
            return returnHelps.map(item => {
              item =>{ item.answer = this.formatHelptext(item.answer),item.answerSafe = this.formatSafeHtmlHelptext(item.answer)}
              return item;
            });
          }), take(1));   
    }
    
    public getItem(id: string): Observable<IHelp> {
      //console.log(`HelpGql.getList(${id})`);
      return this.apollo
          .query({
            query: GetHelpByIdQuery,
            variables: {
                id: id,
            },
          fetchPolicy: 'network-only' 
          })
          .pipe(map(result => 
            { 
              const returnHelp = result.data['helpText'] as IHelp;
              returnHelp.answer = this.formatHelptext(returnHelp.answer);          
              return returnHelp;
            }), take(1));      
    }

    public formatSafeHtmlHelptext(content: string): SafeHtml {
      let resultHtml = content;
      if (!resultHtml) return resultHtml;
  
      resultHtml = this.youTubeLinks(resultHtml);
      resultHtml = this.vemioLinks(resultHtml);
      resultHtml = resultHtml.replace(/(\r\n|\n|\r)/gm, '<br/>');
      return this.sanitizer.bypassSecurityTrustHtml(resultHtml);
    }
  public formatHelptext(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;
    
    resultHtml = this.youTubeLinks(resultHtml);
    resultHtml = this.vemioLinks(resultHtml);

    return resultHtml;
  }

  public youTubeLinks(content:string): string {
    let resultHtml = content;  
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i=0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(match[i], this.createYoutubeEmbed(matchParts[1]));
      }
    }
    return resultHtml;
  }

  public vemioLinks(content:string): string {
    let resultHtml = content;  
    if (!resultHtml) return resultHtml;
    
    const fullreg = /(https?:\/\/)?(www\.)?(vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i=0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(match[i], this.createVimeoEmbed(matchParts[1]));
      }
    }
    return resultHtml;
  }

  public createYoutubeEmbed(key) {
    return '<div class="aspect-ratio-video"><iframe src="' + 'https://www.youtube.com/embed/' + key + '" frameborder="0" allowfullscreen></iframe></div>';
  };

  public createVimeoEmbed(key) {
    return '<div class="aspect-ratio-video"><iframe src="' + 'https://player.vimeo.com/video/' + key + '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>';
  };
}